import { render } from "./StoreInput.vue?vue&type=template&id=c19ddcf0"
import script from "./StoreInput.vue?vue&type=script&lang=js"
export * from "./StoreInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__